(ns app.survey.login.no-process.view
  (:require
   [app.survey.login.no-process.event :as event]
   [app.survey.login.no-process.state :as state]
   [app.survey.login.no-process.sub :as sub]
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.loading-spinner.view :as spinner]
   [ui.dom-globals :as dg]
   [ui.editors.data-input :as data-input]))

(defn email-block
  [disabled?]
  (let [email @(rf/subscribe [::sub/email])
        validated? @(rf/subscribe [::sub/validated?])
        valid-email? @(rf/subscribe [::sub/valid-email?])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "font-semibold text-base-regular-text"}
      (loc/tr :login-using)]
     [data-input/view
      {:data-type   :data.type/email
       :disabled?   disabled?
       :value       email
       ;;Timo how force this placeholder to show?
       :placeholder "e.g. Mary.Smith@reindeer.com"
       :on-blur     #(rf/dispatch [::event/validate-email])
       :on-change   #(rf/dispatch [::event/edit-email %])}]
     (when validated?
       [:span
        {:class "inline-flex items-center gap-2 text-danger-light-text text-xs"}
        (when-not valid-email?
          [:<>
           [:i.fas.fa-info-circle]
           (loc/tr :invalid-email)])])]))

(defn email-vew
  []
  (let [email @(rf/subscribe [::sub/email])
        valid-email? @(rf/subscribe [::sub/valid-email?])]
    [:<>
     [email-block false]
     [:div
      {:class "py-6"}
      [button/primary-solid
       {:on-click  #(rf/dispatch [::event/submit-email])
        :disabled? (or (not valid-email?)
                       (cu/blank-value? email))
        :class     "w-full"}
       (loc/tr :submit)]]]))

(defn phone-block
  []
  (let [phone @(rf/subscribe [::sub/phone])
        validated? @(rf/subscribe [::sub/phone-validated?])
        valid-phone? @(rf/subscribe [::sub/valid-phone?])]
    [:div
     {:class "mt-3 flex flex-col gap-2"}
     [:label
      {:class ""}
      (loc/tr :phone)]
     [data-input/view
      {:data-type :data.type/phone
       :value     phone
       :on-blur   #(rf/dispatch [::event/validate-phone])
       :on-change #(rf/dispatch [::event/edit-phone %])}]
     (when validated?
       [:span
        {:class "text-danger-light-text text-xs"}
        (when-not valid-phone?
          (loc/tr :invalid-phone))])]))

(defn phone-view
  []
  (let [phone @(rf/subscribe [::sub/phone])
        valid-phone? @(rf/subscribe [::sub/valid-phone?])]
    [:<>
     [email-block true]
     [:div
      {:class "py-1 text-xs text-base-light-text-paler"}
      (loc/tr :register-phone-number-for-login-info)]
     [phone-block]
     [:div
      {:class "py-6 flex flex-col gap-3"}
      [button/primary-solid
       {:on-click  #(rf/dispatch [::event/submit-phone])
        :disabled? (or (not valid-phone?)
                       (cu/blank-value? phone))}
       (loc/tr :submit)]
      [:div
       {:class-name "relative flex py-3 items-center"}
       [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]
       [:span {:class-name "flex-shrink mx-4 text-complement-light-text text-xs"} "OR"]
       [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]]
      [button/secondary-hollow
       {:on-click #(rf/dispatch [::event/send-email-token])}
       (loc/tr :authenticate-with-email-token)]
      [button/secondary-open
       {:color    ::c/secondary
        :on-click #(rf/dispatch [::event/cancel-login-process])}
       (loc/tr :cancel)]]]))

(defn email-token-block
  []
  (let [token @(rf/subscribe [::sub/email-token])
        email @(rf/subscribe [::sub/email])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "font-semibold leading-5 text-base-regular-text"}
      (loc/tr :token-from-email [email])]
     [data-input/view
      {:data-type :data.type/text-simple
       :value     token
       :on-change #(rf/dispatch [::event/edit-email-token %])}]]))

(defn phone-token-block
  [masked-phone]
  (let [token @(rf/subscribe [::sub/sms-token])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "font-semibold text-base-regular-text"}
      (loc/tr :token-from-sms [masked-phone])]
     [data-input/view
      {:data-type :data.type/text-simple
       :value     token
       :on-change #(rf/dispatch [::event/edit-sms-token %])}]]))

(defn verify-buttons-block
  []
  [:div
   {:class "py-6 flex flex-col gap-3"}
   [button/primary-solid
    {:disabled? (not @(rf/subscribe [::sub/valid-verification-tokens?]))
     :on-click  #(rf/dispatch [::event/submit-verification-tokens])}
    (loc/tr :submit)]
   [button/secondary-open
    {:on-click #(rf/dispatch [::event/cancel-sms-verification])}
    (loc/tr :cancel)]])

(defn sms-token-buttons-block
  []
  (let [valid-sms-token? @(rf/subscribe [::sub/valid-sms-token?])]
    [:<>
     [:div
      {:class "py-6 flex flex-col gap-3"}
      [button/primary-solid
       {:on-click  #(rf/dispatch [::event/submit-sms-token])
        :disabled? (or (not valid-sms-token?))}
       (loc/tr :submit)]
      [:div
       {:class-name "relative flex py-4 items-center"}
       [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]
       [:span {:class-name "flex-shrink mx-4 text-complement-light-text text-xs"} "OR"]
       [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]]
      [button/secondary-hollow
       {:on-click #(rf/dispatch [::event/send-email-token])}
       (loc/tr :authenticate-with-email-token)]
      [button/secondary-open
       {:on-click #(rf/dispatch [::event/cancel-login-process])}
       (loc/tr :cancel)]]
     [:div
      {:class "text-xs text-center"}
      (loc/tr :did-not-receive-sms?)
      [:a
       {:class    "px-2 text-base-light-text-accent"
        :href     "#"
        :on-click (fn [e]
                    (rf/dispatch [::event/submit-email])
                    (dg/prevent-and-stop e))}
       (loc/tr :send-new-sms)]]]))

(defn sms-sent-view
  []
  (let [masked-phone @(rf/subscribe [::sub/masked-phone])]
    [:<>
     [email-block true]
     [phone-token-block masked-phone]
     [sms-token-buttons-block]]))

(defn verify-phone-view
  []
  (let [phone @(rf/subscribe [::sub/phone])]
    [:<>
     [email-token-block]
     [phone-token-block phone]
     [verify-buttons-block]]))

(defn processing
  []
  [:<>
   [:div
    {:class "flex justify-center"}
    [spinner/circle]]])

(defn email-token-buttons-block
  []
  (let [valid-email-token? @(rf/subscribe [::sub/valid-email-token?])
        masked-phone @(rf/subscribe [::sub/masked-phone])]
    [:div
     {:class "py-6 flex flex-col gap-3"}
     [button/primary-solid
      {:on-click  #(rf/dispatch [::event/submit-email-token])
       :disabled? (or (not valid-email-token?))}
      (loc/tr :submit)]
     [:div
      {:class-name "relative flex py-4 items-center"}
      [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]
      [:span {:class-name "flex-shrink mx-4 text-complement-light-text text-xs"} "OR"]
      [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]]
     (if masked-phone
       [button/secondary-hollow
        {:on-click #(rf/dispatch [::event/send-sms-token])}
        (loc/tr :authenticate-with-sms-token)]
       [button/secondary-hollow
        {:on-click #(rf/dispatch [::event/register-phone])}
        (loc/tr :register-sms)])
     [button/secondary-open
      {:on-click #(rf/dispatch [::event/cancel-login-process])}
      (loc/tr :cancel)]]))

(defn email-sent-view
  []
  [:<>
   [email-token-block]
   [email-token-buttons-block]])

(defn view
  []
  (rf/dispatch [::event/init])
  (fn []
    (let [state @(rf/subscribe [::sub/state])]
      [:<>
       ;[:span (str state)]
       (case state
         ::state/checking-email
         [processing]
         ::state/no-phone-registered
         [phone-view]
         ::state/sent-sms-token
         [sms-sent-view]
         ::state/submitting-sms-token
         [processing]
         ::state/submitting-phone
         [processing]
         ::state/verify-phone-number
         [verify-phone-view]
         ::state/none
         [email-vew]
         ::state/sent-email-token
         [email-sent-view]
         [processing])])))
